export const AvatarSkeletonComponent = {
  templateUrl: 'components/Skeletons/avatar-skeleton/avatar-skeleton.html',
};
